<script lang="ts" setup>
import { ref } from 'vue';
import { useLocale } from '../../composables/useLocale';

type Props = {
  name: string;
  userRole: string;
  email?: string;
  disabled: boolean;
};

defineProps<Props>();

type Emits = {
  (e: 'delete'): void;
  (e: 'undo'): void;
};

const emit = defineEmits<Emits>();

const { t } = useLocale();

const deleteItem = ref<boolean>(false);
const onClickDelete = () => {
  deleteItem.value = !deleteItem.value;
  emit('delete');
};
const onClickUndo = () => {
  deleteItem.value = false;
  emit('undo');
};
</script>
<template>
  <v-row class="px-2">
    <v-col :cols="true">
      <v-row no-gutters>
        <v-col>
          <h4>{{ name }}</h4>
        </v-col>
      </v-row>
      <v-row no-gutters class="ga-1">
        <v-col cols="auto" class="text-capitalize">
          {{ userRole }}
        </v-col>
        <v-col cols="auto">
          <v-icon icon="mdi-email" size="small" color="primary" />
          {{ !!email ? email : t('lcp.email_not_set') }}
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="auto" class="d-flex align-center">
      <v-btn
        :variant="!deleteItem ? 'tonal' : 'outlined'"
        size="small"
        width="122"
        @click="!deleteItem ? onClickDelete() : onClickUndo()"
        :disabled="disabled"
      >
        <template #prepend>
          <Transition :duration="200" name="fade" mode="out-in">
            <v-icon v-if="!deleteItem" icon="mdi-close" />
            <v-icon v-else icon="mdi-restore" />
          </Transition>
        </template>
        <span>
          <Transition :duration="200" name="fade" mode="out-in">
            <span v-if="!deleteItem">{{ t('lcp.remove') }}</span>
            <span v-else>{{ t('lcp.undo') }}</span>
          </Transition>
        </span>
      </v-btn>
    </v-col>

    <v-divider></v-divider>
  </v-row>
</template>
